import {
  MaterialMasterScreen,
  ProvisionScreen,
  StockInOutScreen,
  StockManagementScreen,
  VictuallingScreen,
} from '@felix/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeMaterialsSource } from '../materials-source.js';
import { officeProvisionsSource } from '../provisions-source.js';

/** Malzeme ana listesi (ortak ekran; ADR 0026): ofis kataloğu yönetir ve içe aktarır. */
export function MaterialMasterPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('materials.title')}>
      <MaterialMasterScreen source={officeMaterialsSource} />
    </Shell>
  );
}

/** Stok yönetimi (ortak ekran): geminin stoğu ofiste salt okunur (mimari belge §8). */
export function StockManagementPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('stock.management.title')}>
      <StockManagementScreen source={officeMaterialsSource} />
    </Shell>
  );
}

/** Spare Parts (ortak ekran; ADR 0122 §5): kumanya dışı stok, ofiste salt okunur. */
export function StockInOutPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.inventorySpareParts')}>
      <StockInOutScreen source={officeMaterialsSource} />
    </Shell>
  );
}

/** Kumanya (ortak ekran; ADR 0099): gemi stoğu salt okunur; kütüphane ve uyarı penceresi ofiste. */
export function ProvisionPage() {
  const { t } = useTranslation();
  const source = useMemo(() => officeProvisionsSource(), []);
  return (
    <Shell title={t('menu.inventoryProvision')}>
      <ProvisionScreen source={source} />
    </Shell>
  );
}

/** Aylık iaşe raporu (ADR 0123): filo görünümü ya da seçilen gemi; salt okuma. */
export function VictuallingPage() {
  const { t } = useTranslation();
  const source = useMemo(() => officeProvisionsSource(), []);
  return (
    <Shell title={t('menu.inventoryVictualling')}>
      <VictuallingScreen source={source} />
    </Shell>
  );
}
